import axios from 'axios';
import * as endpoints from '../endpoints';
import { constants } from '../constants';

const baseUrl = constants.baseURL;

export const getQueueFileByMonthAndYear = async (month, year) => {
  return axios({
    method: 'get',
    url: `${endpoints.QueueFiles.BASE}/month/${month}/year/${year}`,
    baseURL: baseUrl,
  }).then((response) => response.data.result?.job || null);
};

export const restartQueueFile = async (id) => {
  return axios({
    method: 'post',
    url: `${endpoints.QueueFiles.BASE}/${id}/restart`,
    baseURL: baseUrl,
  }).then((response) => response.data.result);
};

